import { useTranslation } from 'react-i18next';

import { Laptop } from './Illustrations/Laptop';
import { StatusPage } from './StatusPage';

export const ServerError = () => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<Laptop title={t('status.error_image_title')} />}
			heading={t('status.server_error_title')}
			subheading={t('status.server_error_description')}
			status={500}
		/>
	);
};
